export const CCPA_ANALYTICS = "wonder_ccpa_analytics";
export const CCPA_MARKETING = "wonder_ccpa_marketing";
export const CCPA_PERSONALIZATION = "wonder_ccpa_personalization";
export const ACCESSIBILITY = "wonder_accessibility";
